import ZTLossAttachmentModal from './ZT_loss_attachment-modal.vue'
export default ZTLossAttachmentModal
